import * as React from "react";
import { Text, Box, Img } from "@chakra-ui/react";
import Icon from "../../assets/images/logo.png";

export const Logo = () => (
  <Box paddingRight={3} width="100%" justifySelf="space" textAlign="center">
    <Img
      height="20px"
      float="right"
      src={Icon}
      display="inline-block"
      marginTop="10px"
    />
  </Box>
);
